export enum PermissionsColpatria {
  gestion = 6002,
  gestion_convenios_recaudo = 6017,
  gestion_convenios_pines = 6018,
  gestion_errores = 6019,
  deposito = 6001,
  venta_pines = 6003,
  recaudo = 6004,
  pago_giro = 6005,
  pin_pago = 6006,
  recaudo_sin_limites = 6011,
  corresponsalia_colpatria = 6020,
}
